// extracted by mini-css-extract-plugin
export default {"resumeInterests":"ResumeInterests_resumeInterests__7QdxI","resumeInterest":"ResumeInterests_resumeInterest__mNzux","resumeInterestsFlex":"ResumeInterests_resumeInterestsFlex__qYYGJ"};